import { CloseButton, Flex, Link } from '@chakra-ui/react'
import { CartProductMeta } from './CartProductMeta'

// Displays single item in cart, including name, image, and deletion
export const CartItem = (props) => {
  const {
    // id,
    airbnb_city,
    airbnb_name,
    // airbnb_night_price,
    // airbnb_state,
    // departing_from,
    // departing_to,
    // dest_temp,
    // entry_id,
    // origin_city,
    // price,
    // return_from,
    // return_to,
    onDelete,
  } = props
  return (
    <Flex
      direction={{
        base: 'column',
        md: 'row',
      }}
      justify="space-between"
      align="center"
    >
      <CartProductMeta
        name={airbnb_city}
        description={airbnb_name}
        details={airbnb_name}
        image={`https://source.unsplash.com/random/?vacation,${airbnb_name}`}
      />

      {/* Desktop */}
      <Flex
        width="full"
        justify="space-between"
        display={{
          base: 'none',
          md: 'flex',
        }}
      >
        <CloseButton aria-label={`Delete ${airbnb_name} from cart`} onClick={onDelete} />
      </Flex>

      {/* Mobile */}
      <Flex
        mt="4"
        align="center"
        width="full"
        justify="space-between"
        display={{
          base: 'flex',
          md: 'none',
        }}
      >
        <Link fontSize="sm" textDecor="underline" onClick={onDelete}>
          Delete
        </Link>
      </Flex>
    </Flex>
  )
}